<h2 mat-dialog-title>Alterar Conta Financeira</h2>

<mat-dialog-content>
  <p class="hint-text">
    Selecione a nova conta para {{ data.lancamentos.length }} lançamento(s) selecionado(s). Os saldos das
    contas serão atualizados automaticamente.
  </p>

  @if (isLoading) {
    <div class="loading-state">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
  }

  @if (!isLoading) {
    <div class="conta-section">
      <app-select-pesquisavel
        [control]="contaCtrl"
        label="Nova conta"
        [offlineList]="contaOptions"
        [preloadedOptions]="contaOptions"
        idField="id"
        nameField="descricao">
      </app-select-pesquisavel>
    </div>
  }

  @if (!isLoading) {
    <div class="info-alert">
      <mat-icon class="material-symbols-outlined">info</mat-icon>
      <span
        >Esta ação não pode ser realizada se o período de fechamento financeiro estiver lançado para a data do
        movimento.</span
      >
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button class="btn-secondary" mat-dialog-close>Cancelar</button>
  <button mat-flat-button class="btn-primary" (click)="salvar()" [disabled]="isLoading || !contaCtrl.value">
    Salvar
  </button>
</mat-dialog-actions>
